import React, { Component } from 'react';

class Contact extends Component {
  render() {
    return (
        <div>
          <h2>יצירת קשר</h2>
        </div>
    );
  }
}

export default Contact;
